import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor - attach JWT token
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('visitio_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Response interceptor - handle 401
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // Zle haslo przy logowaniu tez daje 401 — wtedy nie przeladowujemy strony,
    // bo komunikat bledu zniknalby razem z wpisanymi danymi.
    const url = String(error.config?.url || '');
    const isAuthAttempt = /\/auth\/(login|register)/.test(url);
    if (error.response?.status === 401 && !isAuthAttempt) {
      localStorage.removeItem('visitio_token');
      if (window.location.pathname !== '/login') window.location.href = '/login';
    }
    return Promise.reject(error);
  },
);
